var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgInviteTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H42C47.5228 0 52 4.47715 52 10V42C52 47.5228 47.5228 52 42 52H10C4.47715 52 0 47.5228 0 42V10Z",
    fill: "#AA8EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27C24.4295 27.5741 24.9774 28.0492 25.6066 28.3929C26.2357 28.7367 26.9315 28.9411 27.6467 28.9923C28.3618 29.0435 29.0796 28.9404 29.7513 28.6898C30.4231 28.4392 31.0331 28.0471 31.54 27.54L34.54 24.54C35.4508 23.597 35.9548 22.334 35.9434 21.023C35.932 19.712 35.4061 18.4579 34.4791 17.5309C33.5521 16.6039 32.298 16.078 30.987 16.0666C29.676 16.0552 28.413 16.5592 27.47 17.47L25.75 19.18",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9982 25C27.5688 24.4259 27.0209 23.9508 26.3917 23.6071C25.7625 23.2633 25.0667 23.0589 24.3516 23.0077C23.6365 22.9565 22.9187 23.0596 22.2469 23.3102C21.5751 23.5608 20.9651 23.9529 20.4582 24.46L17.4582 27.46C16.5475 28.403 16.0435 29.666 16.0549 30.977C16.0663 32.288 16.5921 33.5421 17.5192 34.4691C18.4462 35.3961 19.7003 35.922 21.0112 35.9334C22.3222 35.9448 23.5852 35.4408 24.5282 34.53L26.2382 32.82",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteTeam);
export default __webpack_public_path__ + "static/media/invite_team.9c35f339.svg";
export { ForwardRef as ReactComponent };